import React, { memo } from 'react';
import { useTheme } from 'emotion-theming';
export var LoggedIn = /*#__PURE__*/memo(function (_ref) {
  var _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'primary' : _ref$variant;

  var _useTheme = useTheme(),
      colors = _useTheme.colors;

  var circleColor = colors.primary;
  var strokeColor = colors.white;

  switch (variant) {
    case 'hover':
      circleColor = colors.secondary;
      break;

    case 'secondary':
      circleColor = colors.white;
      strokeColor = colors.primary;
      break;

    case 'tertiary':
      circleColor = colors.red;
      break;

    case 'primary':
    default:
      circleColor = colors.primary;
      strokeColor = colors.white;
  }

  return /*#__PURE__*/React.createElement("svg", {
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 40.4 40.4",
    style: {
      enableBackground: 'new 0 0 40.4 40.4'
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: circleColor,
    cx: "20.2",
    cy: "20.2",
    r: "20.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: strokeColor,
    strokeWidth: 2.1,
    strokeMiterlimit: 10,
    d: "M20.2,34.6c-8,0-14.4-6.5-14.4-14.4c0-8,6.5-14.4,14.4-14.4c8,0,14.4,6.5,14.4,14.4S28.1,34.6,20.2,34.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: strokeColor,
    strokeWidth: 2.1,
    strokeMiterlimit: 10,
    d: "M20.2,12.6c-2.6,0-4.9,2.2-4.9,4.9V20c0,2.6,2.2,4.9,4.9,4.9s4.9-2.2,4.9-4.9v-2.5 C25,14.8,22.8,12.6,20.2,12.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: strokeColor,
    strokeWidth: 2.1,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M9.1,29c0-3.7,8.5-1.7,7.9-5.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: strokeColor,
    strokeWidth: 2.1,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M23.4,23.7c-0.7,3.6,7.9,1.7,7.9,5.3"
  }));
});